import axios from "axios";


export default axios.create({
    baseURL: process.env.NODE_ENV === "production" ? "https://boostapp.top" : "http://192.168.1.80:8001",
});